export const DATABASE_NAME = 'barbanet_db'
export const DATABASE_VERSION = 1
